<template>
<div class="layout">
  <headerCell></headerCell>
  <div class="wrap-content">
    <focusCell></focusCell>
    <introCell></introCell>
    <picsCell></picsCell>
    <div class="project">
      <div class="text-wrap">
        <img src="../../assets/img/index/project-bg.png" alt="">
        <div class="tit">赢链通</div>
        <div class="des">
          为中小微企业、乃至一些个体经营户解决融资难题，围绕产业集群核心企业提供融资服务，让赢链通平台等新业态可以切实解决中小微企业融资难等一系列问题。
        </div>
      </div>
    </div>
    <div class="consociation">
      <div class="text-wrap">
        <div class="tit">赢链通合作与生态</div>
        <div class="des">专业的金融解决方案，全方位覆盖企业的各种业务场景，为您提供多元化选择</div>
        <div class="btn"><a href="mailto:yuhaotian@caiqilin.com" target="_blank">成为合作伙伴</a></div>
      </div>
    </div>
    <link rel="prefetch" href="../../assets/img/mp4.mp4" />
    <link rel="prefetch" href="../../assets/img/mp4_2.mp4" />
  </div>
  <footerCell></footerCell>
</div>
</template>

<script>
import headerCell from '../../components/header/index';
import footerCell from '../../components/footer/index';
import focusCell from './cell/focusCell'
import introCell from './cell/introCell'
import picsCell from './cell/picsCell'
export default {
  name:'index_page',
  data(){
    return {

    }
  },
  components:{
    headerCell,
    footerCell,
    focusCell,
    introCell,
    picsCell
  },
  methods:{
  },
  mounted() {
    this.$nextTick(() => {
    });
  }
}
</script>
<style lang="less" scoped>
.layout{
  width:100%;
  min-height: 100vh;
  background: #f7f7f7;
  overflow: hidden;
  .project{
    height:245px;
    background: linear-gradient(272.17deg, #0639FC 1.68%, #3772FF 100.72%, #003CFD 100.72%);
    overflow:hidden;
    .text-wrap{
      width:1134px;
      margin:0 auto;
      padding-top:58px;
      position: relative;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 26px;
        line-height: 36px;
        color: #FFFFFF;
        margin-bottom:20px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        width:560px;
      }
      img{
        position: absolute;
        right:-14vw;
        top:0;
      }
    }
  }
  .consociation{
    background: url(../../assets/img/index/consociation-bg.png) repeat-x 0 0;
    width:100%;
    height:388px;
    overflow: hidden;
    .text-wrap{
      margin:0 auto;
      text-align:center;
      padding-top:130px;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 34px;
        color: #333333;
        padding-bottom:9px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 17px;
        color: #333333;
        margin-bottom:20px;
      }
      .btn{
        display: inline-block;
        width: 147px;
        height: 45px;
        line-height: 45px;
        background: #356EF8;
        border-radius: 5px;
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        a{
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>
